import { useState } from "react";
import { Modal } from "react-bootstrap"
import Timer from "../../../../components/timer/Timer";
import ButtonClose from "../../../homeout/principal/components/modal/ButtonClose"

const ModalCodigoSMS = (props) => {

    const handleClose = () => {
        props.close(false)
    }

    const [endTimerStatus, setEndTimerStatus] = useState(false)
    const [timeCode, setTimeCode] = useState(60000)

    const handleSetTimer = (t)=> {
        setTimeCode(t)
    }

    const endTimer = () => {
        setEndTimerStatus(true)
    }

    const [codigo, setCodigo] = useState(["","","",""]);

    const handleChangeInputs = (element, index) => {
        if (isNaN(element.value)) return false;
        setCodigo([...codigo.map((d, idx) => (idx === index ? element.value : d))]);
        if (element.nextSibling) {
            element.nextSibling.focus();
        }
    };

    return (
        <>
            <Modal show={props.show} onHide={handleClose} size="lg" centered>
                <Modal.Body>
                    <ButtonClose close={handleClose} />
                    <div className="modal__codigo-sms">
                        <p>Ingresa el código que enviamos vía SMS a tu celular *******32 para acceder a tu descarga.</p>
                        <div className="campos__codigo">
                            {
                                codigo.map((data, index) => {
                                    return (
                                        <input
                                            className="codigo-field"
                                            type="text"
                                            name="codigo"
                                            key={index}
                                            value={data}
                                            maxLength="1"
                                            onChange={e => handleChangeInputs(e.target, index)}
                                            onFocus={e => e.target.select()}
                                        />
                                    )
                                })
                            }
                        </div>
                        <div className="sms__ayuda" style={{ textAlign: 'center' }}>
                            <p>No he recibido el código</p>
                            <p>Este código expira en <Timer mill={timeCode} end={endTimer} status={endTimerStatus} handleSetTimer={handleSetTimer} /></p>
                            <button className="btn__azul">
                                VALIDAR
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalCodigoSMS